import qs from "qs";
import http from "../http";

function getAlarmList(payload) {
  return http("GET", `${window.API_URL}/alarm/list?${qs.stringify(payload)}`);
}

function setReadAlarmOne(payload) {
  return http("PUT", `${window.API_URL}/alarm/read`, payload);
}

function setUnReadAlarmOne(payload) {
  return http("PUT", `${window.API_URL}/alarm/unread`, payload);
}

function setReadAlarmAll() {
  return http("PUT", `${window.API_URL}/alarm/read/all`);
}

function getAlarmCount() {
  return http("GET", `${window.API_URL}/alarm/status`);
}

function getAnnouncement() {
  return http("GET", `${window.API_URL}/announcement`);
}

export default {
  getAlarmList,
  setReadAlarmOne,
  setUnReadAlarmOne,
  setReadAlarmAll,
  getAlarmCount,
  getAnnouncement,
};
